module.exports = __webpack_public_path__ + "static/media/gutsygibbon.573ce857.jpg";